import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';

export interface CheckboxProps {
    onChange;
    invalid;
    name;
    type?;
    value?;
    label?: string;
}

@observer export class Checkbox extends Component<CheckboxProps, any> {

    render() {
        const { invalid, onChange, name, type, value, label } = this.props;

        return <label style={{fontWeight: 400}}>
            <input type={'checkbox'} checked={!!value} onChange={v => onChange(v.currentTarget.checked)} />&nbsp;&nbsp;
            { label }
        </label>
    }

}
